import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StateOptionContract.json';
import FormError from '../../../../view/FormError';
import Meta from '../../../../model/Meta';

class OptionContractStep1 extends Component {

	constructor(props) {
		super(props);
		this.state = Data;
		
	}

	componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details,
				meetingDate: data.meetingDate
			},			
				()=>{
					this.errorHandle();
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

	}

	componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;
	    const name = target.name;

	    this.setState({
			details: {
				property: {
					...this.state.details.property,
					[name]: value
				},
				seller: this.state.details.seller,
				buyer: this.state.details.buyer,
				payment: this.state.details.payment
			},
			formFocus: "property_"+name
	    },
	    	()=>{
	    		//console.log("State Change: ", this.state);
	    		localStorage.setItem(this.state.formId, JSON.stringify(this.state));
	    		this.errorHandle();

	    	}
	    );
	}

	errorHandle() {
		let errorArray = [];

		if(this.state.details.property.type) {

			if(this.state.details.property.type==="Condominium"){
				if(!this.state.details.property.ctn) {
					let err = {
						"message": `Condominium Certificate of Title number is required.`
					}
					errorArray.push(err);
				}
			}

			if(this.state.details.property.type==="Land" || this.state.details.property.type==="Land with Improvement"){
				if(this.state.details.property.registrationType) {
					if(this.state.details.property.registrationType==="oct"){
						if(!this.state.details.property.oct){
							let err = {
								"message": `Original Certificate of Title number is required.`
							}
							errorArray.push(err);
						}
					}
					if(this.state.details.property.registrationType==="tct"){
						if(!this.state.details.property.tct){
							let err = {
								"message": `Transfer Certificate of Title number is required.`
							}
							errorArray.push(err);
						}
					}
				} else {
					let err = {
						"message": `Please choose registrastion type.`
					}
					errorArray.push(err);
				}
			}
			
			if (!this.state.details.property.address) {
				let err = {
					"message": `Address is required.`
				}
				errorArray.push(err);
			}

			if (!this.state.details.property.contractDate) {
				let err = {
					"message": `Date is required.`
				}
				errorArray.push(err);
			}

			if (!this.state.details.property.contractLocation) {
				let err = {
					"message": `Location is required.`
				}
				errorArray.push(err);
			}

			this.setState({
				formError: errorArray
			},(i)=>{
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				//console.log(this.state.formError);
				this.checkDisplay();
				this.checkCompleteness();		
			})
		}
	}

	checkDisplay() {
		if(this.state.details.property.type!==""){
			$(".options").removeClass("d-none");

			if(this.state.details.property.type==="Condominium") {
				$(".option-condominium").removeClass("d-none");
			} else {
				$(".option-condominium").addClass("d-none");
			}

			if(this.state.details.property.type==="Land" || this.state.details.property.type==="Land with Improvement") {
				$(".option-land").removeClass("d-none");

				if(this.state.details.property.registrationType==="oct") {
					$(".oct-number").removeClass("d-none");
				} else {
					$(".oct-number").addClass("d-none");
				}

				if(this.state.details.property.registrationType==="tct") {
					$(".tct-number").removeClass("d-none");
				} else {
					$(".tct-number").addClass("d-none");
				}

			} else {
				$(".option-land").addClass("d-none");
			}

		} else {
			$(".option").addClass("d-none");
		}
	}

	checkCompleteness() {

		if(this.state.formError.length>0) {
			$(".next").addClass("disabled");
		} else {
			$(".next").removeClass("disabled");
		}

	}

	render() {

		const meta = {
			title: "Property Information - Option Contract",
			description: "Enter property information to create your FREE Option Contract"
		}

		return (
			<div className="page page-inner page-contract">
				<Meta {...meta}/>
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
								
                <ContractCreate />
								
								<ProgressBar percentage={Math.floor((1/6)*100)} />

								<form>

									<div className="mb-4">
										
										<div className="form-group">
											<label htmlFor="contractDate"><span className="font-weight-bold">Date of contract <span className="red asterisk">*</span></span></label>
											<input type="date" name="contractDate" className="form-control" value={this.state.details.property.contractDate} onChange={this.handleChange.bind(this)} placeholder="01/01/2018" />
										</div>

										<div className="form-group">
											<label htmlFor="contractLocation"><span className="font-weight-bold">Location <span className="red asterisk">*</span></span></label>
											<input type="text" name="contractLocation" className="form-control" value={this.state.details.property.contractLocation} onChange={this.handleChange.bind(this)} placeholder="(e.g. Makati)" />
										</div>

										<div className="form-group">
											<label htmlFor="country"><span className="font-weight-bold">In which country will the agreement be executed? <span className="red asterisk">*</span></span></label>
											<select className="form-control" id="country">
												<option value="Philippines">Philippines</option>
											</select>
										</div>
									</div>

									<p className="label"><strong>What type of real property are you selling?<span className="red asterisk">*</span></strong></p>

									{/* Property type */}
									<div>
										<div className="form-check">
											<label className="form-check-label">
												<input className="form-check-input" type="radio" name="type" id="property-type-1" value="Condominium" onChange={this.handleChange.bind(this)} checked={this.state.details.property.type === 'Condominium'} />
													Condominium
												</label>
										</div>
										<div className="form-check">
											<label className="form-check-label">
												<input className="form-check-input" type="radio" name="type" id="property-type-2" value="Land" onChange={this.handleChange.bind(this)} checked={this.state.details.property.type === 'Land'} />
													Land
												</label>
										</div>
										<div className="form-check">
											<label className="form-check-label">
												<input className="form-check-input" type="radio" name="type" id="property-type-3" value="Land with Improvement" onChange={this.handleChange.bind(this)} checked={this.state.details.property.type === 'Land with Improvement'} />
													Land with Improvement
												</label>
										</div>
									</div>

									<div className="options d-none">

										{/* Condominium option */}
										<div className="option-condominium d-none pt-3">
											<div className="form-group">
												<label htmlFor="ctn">
													<span className="font-weight-bold">What is its Condominium Certificate of Title Number?</span><span className="red asterisk">*</span>
												</label>
												<input className="form-control" name="ctn" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.property.ctn} placeholder="(e.g. CCT No. A-123456)" />
											</div>
											
										</div>

										{/* Land option */}
										<div className="option-land d-none">
											<div className="pt-3">
												<p className="label"><strong>What is its form of registration?</strong><span className="red asterisk">*</span></p> 
												<div className="form-check">
													<label className="form-check-label">
														<input className="form-check-input" type="radio" name="registrationType" id="land-2" value="oct" onChange={this.handleChange.bind(this)} checked={this.state.details.property.registrationType === 'oct'} />
															Original Certificate of Title (OCT)
														</label>
												</div>
												<div className="form-check">
													<label className="form-check-label">
														<input className="form-check-input" type="radio" name="registrationType" id="land-2" value="tct" onChange={this.handleChange.bind(this)} checked={this.state.details.property.registrationType === 'tct'} />
															Transfer Certificate of Title (TCT)
														</label>
												</div>
											</div>

											<div className="pt-3 oct-number d-none">
												<label htmlFor="oct">
													<span className="font-weight-bold">What is its OCT number?</span><span className="red asterisk">*</span>
												</label>
												<input className="form-control" name="oct" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.property.oct} placeholder="(e.g. OCT No. 123456)" />
											</div>

											<div className="pt-3 tct-number d-none">
												<label htmlFor="oct">
													<span className="font-weight-bold">What is its TCT number?</span><span className="red asterisk">*</span>
												</label>
												<input className="form-control" name="tct" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.property.tct} placeholder="(e.g. TCT No. 123456)" />
											</div>

										</div>

										{/* Land with improvement option */}
										<div className="option-land-with-improvement d-none pt-3">
										</div>

										<div className="form-group pt-3">
											<label htmlFor="address">
												<span className="font-weight-bold">What is the address of the real property subject of the sale?</span><span className="red asterisk">*</span>
											</label>
											<input className="form-control" name="address" type="text" onChange={this.handleChange.bind(this)} value={this.state.details.property.address} placeholder="(e.g. No. Street, City, Province, Country, Zip Code)" />
										</div>

									</div>
								</form>

								{/** Navs */}
								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 1/6</p>
									<FormError errors={this.state.formError} />
									<div className="row">
										<div className="col-6">
											<Link to={this.state.formPath} className="btn btn-lightblue w-100">Back</Link>
										</div>
										<div className="col-6">
											<Link to={this.state.formPath+"/2"} className="btn btn-lightblue disabled next w-100">Next</Link>
										</div>
									</div>
								</div>

							</div>
							<div className="col-12 col-md-7 right-preview">
								<Preview {...this.state} />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default OptionContractStep1;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/option-contract/OptionContractStep1.js